import { gql } from '@apollo/client';

export interface CarpoolTripUser {
  id: string;
  firstname: string | null;
  lastname: string | null;
  nickname: string | null;
  studyTown: string | null;
  studies: string | null;
}

export interface CarpoolTripData {
  id: string;
  pickupExactLocation: string;
  pickupTown: string;
  pickupAt: string;
  seats: number;
  remainingSeats: number;
  description: string | null;
  driver: CarpoolTripUser;
  passengers: CarpoolTripUser[];
}

export interface CarpoolTripsQuery {
  carpoolTrips: CarpoolTripData[];
}

export interface CarpoolTripsQueryVariables {
  eventId: string;
}

export const CARPOOL_TRIPS = gql`
  query CarpoolTrips($eventId: ID!) {
    carpoolTrips(eventId: $eventId) {
      id
      pickupExactLocation
      pickupTown
      pickupAt
      seats
      remainingSeats
      description
      driver {
        id
        firstname
        lastname
        nickname
        studyTown
        studies
      }
      passengers {
        id
        firstname
        lastname
        nickname
        studyTown
        studies
      }
    }
  }
`;
